import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendar,
  faPen,
  faCode,
  faCog,
  faRocket,
  faShieldAlt,
  faSmile,
  faGlobe,
  faDesktop,
  faMobileAlt,
  faPlane,
  faCar,
  faGraduationCap,
  faCogs,
  faHome,
  faShoppingCart,
  faTheaterMasks,
  faMoneyCheckAlt,
  faLaptopCode,
  faUtensils,
  faTruck,
  faHeartbeat,
  faDatabase,
  faChartLine,
  faTools,
} from "@fortawesome/free-solid-svg-icons";
import "./HomeAdd.css";

const HomeAdd = () => {
  return (
    <div className="home-container">
      {/* Working Process Section */}
      <section className="working-process">
        <h2>
          Our <span className="highlight">Development Process</span>
        </h2>
        <div className="process-container">
          {[
            {
              icon: faCalendar,
              title: "Requirement Analysis",
              description:
                "We start by understanding your business needs and project requirements to create a tailored solution.",
            },
            {
              icon: faPen,
              title: "Design & Prototyping",
              description:
                "Our team designs intuitive user interfaces and creates prototypes to ensure the best user experience.",
            },
            {
              icon: faCode,
              title: "Development",
              description:
                "We develop robust web, mobile, and desktop applications using the latest technologies.",
            },
            {
              icon: faCog,
              title: "Testing & Optimization",
              description:
                "Rigorous testing and performance optimization ensure your software runs smoothly and efficiently.",
            },
            {
              icon: faRocket,
              title: "Deployment & Support",
              description:
                "We deploy the final product and provide ongoing support to ensure your software remains up-to-date and secure.",
            },
          ].map((step, index) => (
            <div className="process-step" key={index}>
              <div className="icon">
                <FontAwesomeIcon icon={step.icon} className="icon-3d" />
              </div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <h1>Our Expertise</h1>
        <div className="feature-container">
          {[
            {
              icon: faShieldAlt,
              title: "Secure Solutions",
              description:
                "We prioritize security, ensuring your software is protected against vulnerabilities.",
            },
            {
              icon: faDatabase,
              title: "Database Optimization",
              description:
                "We optimize databases for faster queries and efficient data management.",
            },
            {
              icon: faChartLine,
              title: "Performance Tuning",
              description:
                "Our team ensures your software performs at its best under all conditions.",
            },
            {
              icon: faTools,
              title: "Maintenance & Support",
              description:
                "We provide continuous maintenance and support to keep your software running smoothly.",
            },
          ].map((feature, index) => (
            <div className="feature-box" key={index}>
              <div className="icon">
                <FontAwesomeIcon icon={feature.icon} className="icon-3d" />
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="fun-facts">
        <h2>Our Achievements</h2>
        <div className="facts-container">
          {[
            { count: 150, label: "Happy Clients", icon: faSmile },
            { count: 300, label: "Projects Delivered", icon: faCode },
            { count: 200, label: "Websites Developed", icon: faGlobe },
            { count: 100, label: "Mobile Apps Built", icon: faMobileAlt },
            { count: 50, label: "Desktop Applications", icon: faDesktop },
          ].map((fact, index) => (
            <div className="fact-box" key={index}>
              <div className="icon">
                <FontAwesomeIcon icon={fact.icon} className="icon-3d" />
              </div>
              <h3>{fact.count}+</h3>
              <p>{fact.label}</p>
            </div>
          ))}
        </div>
      </section>

     
    </div>
  );
};

export default HomeAdd;
